import { ConsignmentStockInCreatePage } from "@/features/consignment-stockin/pages/ConsignmentStockInCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockin/create")({
	beforeLoad() {
		throw redirect({ to: "/admin/consignment-stockin" });
	},
	component: ConsignmentStockInCreatePage,
});
